// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "app/" + chunkId + "." + {"461":"c6e160408239fb5da634","1874":"76d1a0b7bacea165ff6e"}[chunkId] + ".css";
};